module.exports = __webpack_public_path__ + "static/img/02.a13188f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour1/02.jpg
// module id = 38/4
// module chunks = 0